import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Swal from "sweetalert2";

import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";

export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [unitLists, setUnitLists] = useState([]);
  const [type, setType] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [treatLists, setTreatLists] = useState([]);

  const [conValue, setConValue] = useState("");

  const [value, setValue] = useState("");
  const [defineTotalAmount, setDefineTotalAmount] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [showValue, setShowValue] = useState(false);
  const [showItem, setShowItem] = useState(false);

  const [expDays, setExpDays] = useState(0);
  const [itemBaseQty, setItemBaseQty] = useState(0);

  const [showBody, setShowBody] = useState(false);
  const [showExpDay, setShowExpDay] = useState(false);
  const [showItemBase, setShowItemBase] = useState(false);
  const [itemID, setItemID] = useState("");
  const [discountType, setDiscountType] = useState(false);

  // FOC state
  const [focProductId, setFocProductId] = useState("");
  const [focItemLists, setFocItemLists] = useState([]);
  const [focItemId, setFocItemId] = useState("");
  const [focQty, setFocQty] = useState(1);

  //If FOCItem , Item
  const handleBodyPart = (event) => {
    setItemID(event);
  };

  // Fetch FOC items when product changes
  useEffect(() => {
    if (!focProductId) {
      setFocItemLists([]);
      setFocItemId("");
      return;
    }
    const fetch = async () => {
      try {
        const res = await api.get(
          `medicine-items?relatedProduct=${focProductId}`,
        );
        setFocItemLists(res.data.list || []);
      } catch (err) {}
    };
    fetch();
  }, [focProductId]);

  //Type
  const handleType = (event) => {
    setType(event);
    if (event === "FOC") {
      setShowValue(false);
    } else {
      setShowValue(true);
    }
    setShowItem(false);
  };
  const handleDiscountType = (value) => {
    setDiscountType(value);
  };
  //Create
  const DiscountCreate = () => {
    const data = {
      discountName: name,

      discountRate: type,
      description: description,
      discountValue: parseInt(value),
      discountType: discountType,
    };
    if (discountType === "Expired") {
      data.expiredDay = Number(expDays);
    } else if (discountType === "Voucher") {
      data.certainAmount = parseInt(defineTotalAmount);
    } else if (discountType === "quantityBased") {
      data.itemBase = Number(itemBaseQty);
    }

    if (type === "FOC") {
      data.discountValue = 0;
      data.focItem = focItemId ? [focItemId] : [];
      data.focQty = focQty ? Number(focQty) : 1;
    }

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .post("item-discounts", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Discount Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });

        props.setDisLists([...props.disLists, response.data.data]);
      })

      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Error",
          icon: "warning",
          showConfirmButton: false,
          timer: 2000,
        });
      });
    props.close();
  };

  useEffect(() => {
    const getTreatmentList = async () => {
      try {
        const res = await api.get("medicine-lists");
        setTreatLists(res.data.list);
      } catch (err) {}
    };
    getTreatmentList();
  }, []);

  // When product changes, fetch items filtered by that product
  useEffect(() => {
    if (!itemID) {
      setUnitLists([]);
      return;
    }
    const getItemsByProduct = async () => {
      try {
        const res = await api.get(`medicine-items?relatedProduct=${itemID}`);
        setUnitLists(res.data.list);
      } catch (err) {}
    };
    getItemsByProduct();
  }, [itemID]);

  return (
    <div>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className="modal-header ok">
            <h4 className="modal-title">Create Discount</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          {/* @csrf */}
          <div class="modal-body">
            <div class="form-group w-100">
              <label for="name">Name</label>
              <input
                type="text"
                class="form-control border border-info"
                name="name"
                placeholder="Discount Name eg. 10% off, summer sale"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div class="form-group ml-1 w-100">
              <label for="name">Discount Type</label>
              <select
                class="custom-select border-info"
                name="account_type_id"
                id="cat"
                onChange={(e) => handleDiscountType(e.target.value)}
              >
                <option hidden>Choose</option>
                <option value="Voucher">Voucher</option>
                <option value="Expired">Expired Date</option>
                <option value="quantityBased">Item Base</option>
              </select>
            </div>
            {discountType === "Expired" && (
              <div class="form-group  w-100">
                <label for="name">Expired Days</label>
                <input
                  type="number"
                  class="form-control border border-info"
                  name="name"
                  placeholder="Enter number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setExpDays(e.target.value)}
                />
              </div>
            )}
            {discountType === "quantityBased" && (
              <div class="form-group  w-100">
                <label for="name">Item Base Quantity</label>
                <input
                  type="number"
                  class="form-control border border-info"
                  name="name"
                  placeholder="Enter number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setItemBaseQty(e.target.value)}
                />
              </div>
            )}
            {discountType === "Voucher" && (
              <div class="form-group w-100">
                <label for="name">Certain Amount</label>
                <input
                  type="number"
                  class="form-control border border-info"
                  name="name"
                  placeholder="Enter number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setDefineTotalAmount(e.target.value)}
                />
              </div>
            )}
            {discountType !== "Voucher" && (
              <>
                <div div class="form-group ml-1 w-100">
                  <label for="name">Products</label>
                  <select
                    class="custom-select border-info"
                    id="subCat"
                    name="account_type_id"
                    onChange={(e) => handleBodyPart(e.target.value)}
                  >
                    <option hidden>Choose</option>

                    {treatLists.map((item) => (
                      <option value={item._id}>{item?.name}</option>
                    ))}
                  </select>
                </div>

                <div class="form-group ml-1 w-100">
                  <label for="name">Items</label>
                  <select
                    name="currency"
                    id=""
                    className="form-control mt-1"
                    onchange="convert(this.value)"
                  >
                    <option hidden>Choose</option>

                    {unitLists
                      .filter((el) => el.name?._id === itemID)
                      .map((option) => (
                        <option value={option._id}>
                          {option.medicineItemName}
                        </option>
                      ))}
                  </select>
                </div>
              </>
            )}

            <div class="form-group ml-1 w-100">
              <label for="name">Discount Method</label>
              <select
                class="custom-select border-info"
                name="account_type_id"
                id="cat"
                onChange={(e) => handleType(e.target.value)}
              >
                <option hidden>Choose Type</option>
                <option value="Amount">Amount</option>
                <option value="Percent">Percent</option>
                <option value="FOC">FOC</option>
              </select>
            </div>
            {type === "FOC" ? (
              <>
                <div class="form-group ml-1 w-100">
                  <label for="name">Free Product</label>
                  <select
                    class="custom-select border-info"
                    value={focProductId}
                    onChange={(e) => setFocProductId(e.target.value)}
                  >
                    <option value="">Choose</option>
                    {treatLists.map((item) => (
                      <option value={item._id}>{item?.name}</option>
                    ))}
                  </select>
                </div>

                <div class="form-group ml-1 w-100">
                  <label for="name">Free Item</label>
                  <select
                    class="custom-select border-info"
                    value={focItemId}
                    onChange={(e) => setFocItemId(e.target.value)}
                  >
                    <option value="">Choose</option>
                    {focItemLists
                      .filter(
                        (el) => !focProductId || el.name?._id === focProductId,
                      )
                      .map((opt) => (
                        <option value={opt._id}>{opt.medicineItemName}</option>
                      ))}
                  </select>
                </div>

                <div class="form-group ml-1 w-100">
                  <label for="name">Free Qty</label>
                  <input
                    type="number"
                    min="1"
                    class="form-control border border-info"
                    value={focQty}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => setFocQty(e.target.value)}
                  />
                </div>
              </>
            ) : (
              showValue && (
                <div class="form-group w-100">
                  <label for="name">Value</label>
                  <input
                    type="number"
                    class="form-control border border-info"
                    name="name"
                    placeholder="Enter number"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => setValue(e.target.value)}
                  />
                </div>
              )
            )}

            <div class="form-group ml-2 w-100">
              <label for="name">Description</label>
              <textarea
                className="form-control"
                id="description"
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <Button
              class="btn btn-secondary"
              data-dismiss="modal"
              onClick={props.close}
            >
              Close
            </Button>
            <Button class="btn btn-primary" onClick={DiscountCreate}>
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
